import React from "react";
import "../../styles/imageStyles.css";

interface SquareIconProps {
  icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  squareBg?: boolean;
  size?: "sm" | "md" | "lg" | "xl" | "2xl" | "3xl" | "4xl";
  squareSize?: "sm" | "md" | "lg" | "xl" | "2xl" | "3xl" | "4xl";
}

export const SquareIcon: React.FC<SquareIconProps> = ({
  icon: IconComponent,
  squareBg = false,
  size,
  squareSize = "3xl",
}) => {
  if (!IconComponent) {
    return null;
  }
  const iconSize = size || (squareBg && "xl") || "lg";
  const sizeClass = `icon-${iconSize}`;

  if (squareBg) {
    return (
      <div className={`square icon-${squareSize} bg-basic-200`}>
        <IconComponent className={sizeClass} />
      </div>
    );
  }

  return <IconComponent className={sizeClass} />;
};
